/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Cl_PoweredInputs */

const en_st_cl_powered = /** @type {(inputs: St_Cl_PoweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powered by Bystep`)
};

const id_st_cl_powered = /** @type {(inputs: St_Cl_PoweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powered by Bystep`)
};

/**
* | output |
* | --- |
* | "powered by Bystep" |
*
* @param {St_Cl_PoweredInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_cl_powered = /** @type {((inputs?: St_Cl_PoweredInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Cl_PoweredInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_cl_powered(inputs)
	return en_st_cl_powered(inputs)
});